import React from "react";
import "./EmptyCartSvg.css";
function EmptyCartSvg() {
  return (
    <div className="empty-cart">
      <img
        src="https://i.postimg.cc/KzgCFYHz/empty-cart-2130356-1800917.png"
        alt="Empty Cart"
        className="img-responsive"
      />
    </div>
  );
}

export default EmptyCartSvg;
